import React, { useState, useEffect, useCallback, useContext } from "react";
import {
  Box,
  Typography,
  Paper,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  Tab,
  Select,
  MenuItem,
  Chip,
  CircularProgress,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grid from "@mui/material/Grid2"; 
import InputFilter from "../GeneralComponents/InputFilter";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import ListEmpty from "../GeneralComponents/ListEmpty";
import PageButtonWhite from "../GeneralComponents/PageButtonWhite";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import GeneralContext from "../GeneralContext/GeneralContext";
import axios from "../../api/axios";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import ModalStandardCancel from "../GeneralComponents/ModalStandardCancel";
import RepresentantesModalAdd from "../Representantes/RepresentantesModalAdd";
import * as XLSX from "xlsx";
import ModalMassiveRepresentantes from "../GeneralComponents/ModalMassiveRepresentantes";
import {ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN} from "../../Constants/Constants";
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';


const columns = [
  {
    id: "checkbox",
    label: "",
    width: "5%",
    minWidth: "50px",
    align: "left",
  },
  { id: "rbd", label: "RBD", width: "5%", minWidth: "80px" },
  { id: "ultimo_intento_creado_por", label: "Nombre", width: "12%", minWidth: "80px" },
  { id: "direccion_ultimo_intento", label: "Nueva Dirección", width: "12%", minWidth: "120px" },
  { id: "direccion_ees", label: "Dirección actual", width: "12%", minWidth: "120px" },
  { id: "email", label: "Email", width: "12%", minWidth: "120px" },
  { id: "estado", label: "Verificación en dirección", width: "12%", minWidth: "120px" },
  { id: "ultimo_intento_internet_ok", label: "Conexion en dirección", width: "12%", minWidth: "120px" },
  { id: "fecha_ultimo_intento", label: "Fecha de actualización", width: "12%", minWidth: "120px" },
  {
    id: "run",
    label: "RUN",
    width: "16%",
    minWidth: "120px",
    align: "left",
  },
  {
    id: "tipo_representante",
    label: "Tipo Representante",
    width: "12%",
    minWidth: "100px",
    align: "left",
  },
];

const mapEstadoApiToUi = (estadoApi) => {
  const e = (estadoApi ?? "").trim();
  if (!e) return "No iniciada";
  if (e === "Pendiente") return "Por verificar";
  if (e === "Verificado") return "Verificada";
  if (e === "No Verificado") return "Rechazada";
  return "No iniciada";
};

  const mapEstadoUiToApi = (estadoUi) => {
  const e = (estadoUi ?? "").trim();
  if (e === "Por verificar") return "Pendiente";
  if (e === "Verificada") return "Verificado";    
  if (e === "Rechazada") return "No Verificado";  
  if (e === "No iniciada") return "";             
  return e;
};

export default function DireccionesList() {
  const theme = useTheme();
  const [rows, setRows] = useState([]);
  const { includeRol, pageTitle, setPageTitle, userSesion } = useContext(GeneralContext);
  const [filters, setFilters] = useState({});
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const [selected, setSelected] = useState([]);
  const [tabFilter, setTabFilter] = useState("Todos"); 
  const [action, setAction] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = (action) => {setAction(action); setOpen(true);}
  const handleClose = (fromModal, successfulCount) =>{ setOpen(false); fetchData(fromModal, successfulCount)}
  const navigate = useNavigate();


  const [openAdd, setOpenAdd] = React.useState(false);
  const handleOpenAdd = () => { setOpenAdd(true);}
  const handleCloseAdd = (fromModal, successfulCount) =>{ setOpenAdd(false); fetchData(fromModal, successfulCount)}

  const [currentRow, setCurrentRow] = React.useState(null);
  const [verifyMsg, setVerifyMsg] = React.useState("");
  const [addressNewState, setAddressNewState] = React.useState("");
  const [openVerify, setOpenVerify] = React.useState(false);
  const handleOpenVerify = (row, newValue) => {setCurrentRow(row); setAddressNewState(newValue); setVerifyMsg(`¿Está seguro de verificar la dirección ${row.direccion_ultimo_intento} para el RBD ${row.rbd}?`); setOpenVerify(true);}
  const handleCloseVerify = () =>{ setOpenVerify(false); }

  const fetchData = async (fromModal : boolean = false, count: number = 0) => {
    if(fromModal && count === 0){
      return;
    }
    setLoading(true);
    try {
      const response = await axios.getDireccionesRBD();
      const modifiedData = (response.data ?? []).map((row) => ({
        ...row,
        key: String(row.rbd),
        checkbox: "",
        estado_api: row.estado ?? null,     
        estado: mapEstadoApiToUi(row.estado), 
      }));
      setRows(modifiedData);
      setTableData(modifiedData);

      const columnOrder = [
        "checkbox",
        "rbd",
        "direccion_ees",
        "direccion_ultimo_intento",
        "ultimo_intento_creado_por",

        "email",
        "fecha_ultimo_intento",
        "estado",
        "ultimo_intento_internet_ok",
      ];
      setFilteredColumns(
        columnOrder
          .map((id) => columns.find((column) => column.id === id))
          .filter(Boolean)
      );
    if (count !== 0){
      applyFilters(modifiedData);
    }
    setTabFilter("Todos");
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    setPageTitle("VERIFICACIÓN DE DIRECCIÓN EES");
  }, [pageTitle, setPageTitle]);


  const applyFilters = useCallback(() => {
    let filtered = Object.keys(filters).length
      ? rows.filter((item) =>
          Object.entries(filters).every(([key, val]) => item[key] === val)
        )
      : rows.slice();

    if (tabFilter === "Verificada") {
      filtered = filtered.filter((r) => r.estado === "Verificada");
    } else if (tabFilter === "Por verificar") {
      filtered = filtered.filter((r) => r.estado === "Por verificar");
    } else if (tabFilter === "Rechazada") {
      filtered = filtered.filter((r) => r.estado === "Rechazada");
    } else if (tabFilter === "No iniciada") {
      filtered = filtered.filter((r) => r.estado === "No iniciada");
    }

    if (JSON.stringify(filtered) !== JSON.stringify(tableData)) {
      setSelected([]);
    }

    const maxPage = Math.floor((filtered.length - 1) / rowsPerPage);
    if (page > maxPage) {
      setPage(0);
    }

    setTableData(filtered);
  }, [filters, rows, tabFilter, rowsPerPage, page, tableData]);

  useEffect(() => {
    applyFilters();
  }, [filters, tabFilter, rows, applyFilters]);

  const filterRecords = (name, value) => {
    let filterObj = { ...filters };
    if (value == null) {
      delete filterObj[name];
    } else {
      filterObj[name] = value;
    }
    setFilters(filterObj);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const displayedRows = tableData;

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelecteds = tableData.map((n) => n.key);
      setSelected(newSelecteds);
    } else {
      setSelected([]);
    }
  };

  const handleCheckboxClick = (key) => {
    const selectedIndex = selected.indexOf(key);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, key);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (key) => selected.indexOf(key) !== -1;




  const callChangeApi = async () => {
    const data = {
      estado: mapEstadoUiToApi(addressNewState),
      validado_por: userSesion?.nombre,
      observaciones: "nada",
      direccion: currentRow.direccion_ultimo_intento,
    };

    try {
      setLoading(true);
      await axios.changeAddresStatus(currentRow.rbd, data);

      handleChangeType(currentRow.key, addressNewState, {
        direccion_ees:
          addressNewState === "Verificada"
            ? currentRow.direccion_ultimo_intento
            : currentRow.direccion_ees,
      });
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }

    handleCloseVerify();
  };

  const handleChangeType = (key, newType, extraUpdates = {}) => {
    setRows((prev) =>
      prev.map((r) =>
        r.key === key
          ? {
              ...r,
              estado: newType,
              ...extraUpdates,
            }
          : r
      )
    );

    setTableData((prev) =>
      prev.map((r) =>
        r.key === key
          ? {
              ...r,
              estado: newType,
              ...extraUpdates,
            }
          : r
      )
    );
  };


  const handleTabChange = (event, newValue) => {
    setSelected([]);
    setTabFilter(newValue);
  };

  const chipColor = (tipo) => {
    switch (tipo) {
      case "Verificada":
        return "#2E7D32";
      case "Por verificar":
        return "#FFE263";
      case "Rechazada":
        return "#FF5722";
      case "No iniciada":
        return "#ABABB5"; 
      default:
        return "#ABABB5";
    }
  };


    const downloadXLS = () => {
  //const selectedRows = tableData.filter((row) => selected.includes(row.id));

  const selectedRows = tableData;
  if (selectedRows.length === 0) {
    alert("No hay filas seleccionadas para descargar.");
    return;
  }

  /*const filteredData = selectedRows.map((row) => ({
    rbd: row.rbd,
    folio: row.folio,
    periodos: row.periodos.join(", "),
    tipo_contingencia: row.tipo_contingencia,
    id_operador: row.id_operador,
    operador: row.operador,
    rut_emisor: row.rut_emisor,
    id_zona: row.id_zona,
    estado: row.estado,
    estado_resumen: row.estado_resumen,
    fecha_creacion: row.fecha_creacion,
    fecha_inicio: row.tipo_contingencia === "PROGRAMADA" ? row.programada_inicio_contingencia+"T"+row.programada_hora_inicio : row.especifica_fecha_hora_ocurrencia ,
    fecha_termino: row.tipo_contingencia === "PROGRAMADA" ? row.programada_fin_contingencia+"T"+row.programada_hora_termino : row.especifica_fecha_hora_resolucion ,
    descripcion: row.tipo_contingencia === "PROGRAMADA" ? row.programada_descripcion : row.especifica_descripcion_falla,
    link_documento: row.ruta_url,
  }));*/




    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tabla");
    XLSX.writeFile(workbook, "tabla_representantes.xlsx");
  };

  return (
    <PageBody>
      <Box width="100%">
        <Grid container spacing={1} sx={{ marginBottom: "28px", marginTop: "-2rem" }} columns={12}>
          <Grid size={3}>
            <InputFilter data={rows} item={"rbd"} name={"RBD"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"ultimo_intento_creado_por"} name={"Nombre"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"email"} name={"Email"} callback={filterRecords} />
          </Grid>
          <Grid size={3}>
            <InputFilter data={rows} item={"conexion_direccion"} name={"Conexión en dirección"} callback={filterRecords} />
          </Grid>
        </Grid>

        <Paper
          sx={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            justifyContent: "center",
            background: "#FFFFFF",
            borderRadius: "0.25rem",
            marginBottom: "0.75rem",
          }}
        >
          <Typography
            variant="h1"
            color="inherit"
            noWrap
            sx={{ textAlign: "center", padding: "0.5rem" }}
          >
            VERIFICACIÓN DE DIRECCIÓN EES
          </Typography>
        </Paper>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
              width: "100%",
              backgroundColor: "white",
            }}
          >
            <CircularProgress />
            <Typography variant="h6" sx={{ marginTop: 2 }}>
              Cargando...
            </Typography>
          </Box>
        ) : (
          <>
            <PageBgBlock pad="0">
              <Paper
                sx={{
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "center",
                  background: "#FFFFFF",
                  borderRadius: "0.25rem",
                  marginBottom: "0.75rem",
                }}
              >
                {/* Pestañas */}
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 2, backgroundColor: "#fff" }}>
                  <Tabs
                    value={tabFilter}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{
                      backgroundColor: "#fff",
                      "& .MuiTabs-indicator": {
                        height: 3,
                        backgroundColor: theme.palette.primary.main,
                      },
                    }}
                  >
                    <Tab
                      label="Todos"
                      value="Todos"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                    <Tab
                      label="Verificada"
                      value="Verificada"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                    <Tab
                      label="Por verificar"
                      value="Por verificar"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                    <Tab
                      label="Rechazada"
                      value="Rechazada"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                    <Tab
                      label="No iniciada"
                      value="No iniciada"
                      sx={{
                        textTransform: "none",
                        fontWeight: 500,
                        color: theme.palette.text.secondary,
                        "&.Mui-selected": {
                          color: theme.palette.primary.main,
                          backgroundColor: "#E3F2FD",
                          borderTopLeftRadius: 4,
                          borderTopRightRadius: 4,
                        },
                      }}
                    />
                  </Tabs>
                </Box>

                <TableContainer>
                  <Table size="small" aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {filteredColumns.map((column, index) => (
                          <TableCell
                            key={"CL" + index}
                            align={column.align}
                            style={{ minWidth: column.minWidth }}
                          >
                            {column.id === "checkbox" ? (
                              <Box display="flex" alignItems="center">
                                <Checkbox
                                  color="primary"
                                  indeterminate={
                                    selected.length > 0 &&
                                    selected.length < displayedRows.length
                                  }
                                  checked={
                                    selected.length > 0 &&
                                    selected.length === displayedRows.length
                                  }
                                  onChange={handleSelectAll}
                                  inputProps={{ "aria-label": "select all" }}
                                />
                                {column.label}
                              </Box>
                            ) : (
                              column.label
                            )}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {displayedRows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row, rowIndex) => {
                          const isItemSelected = isSelected(row.key);
                          return (
                            <TableRow
                              hover
                              role="checkbox"
                              tabIndex={-1}
                              key={"TR" + rowIndex}
                            >
                              {filteredColumns.map((column, colIndex) => {
                                const value = row[column.id];
                                if (column.id === "checkbox") {
                                  return (
                                    <TableCell
                                      key={"TC" + colIndex + rowIndex}
                                      align={column.align}
                                    >
                                      <Checkbox
                                        color="primary"
                                        checked={isItemSelected}
                                        onClick={() => handleCheckboxClick(row.key)}
                                        inputProps={{
                                          "aria-labelledby": row.key,
                                        }}
                                      />
                                    </TableCell>
                                  );
                                } else if (column.id === 'ultimo_intento_internet_ok') 


                                { return (
                                    <TableCell
                                      key={"TC" + colIndex + rowIndex}
                                      align={column.align}
                                    >
                
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'no-wrap',
                    }}>
                      <FiberManualRecordIcon sx={{ fontSize: "0.75rem", color: value ? '#41AE43' : !value ? '#FB3B3B' : '#FB3B3B' , marginRight: "0.5rem" }} />

                      {value ? "Sí" : "No"}
                     
                    </div>
                    </TableCell>

                )




                              } else if (column.id === "estado") {
                                  const current = row.estado;
                                  let options = [];
                                  if (current === "Por verificar") {
                                    options = ["Verificada", "Rechazada"];
                                  } 
                                  return (
                                    <TableCell
                                      key={"TC" + colIndex + rowIndex}
                                      align={column.align}
                                    >
                                      <Select
                                      disabled={!includeRol([ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN])}
                                        value={current}
                                        onChange={(e) =>
                                          handleOpenVerify(row, e.target.value)
                                        }
                                        variant="standard"
                                        disableUnderline
                                        IconComponent={ExpandMoreIcon}
                                          sx={{
                                            minWidth: "180px",
                                            "&.Mui-disabled .MuiChip-root": {
                                              opacity: 1,
                                              backgroundColor: chipColor(current),
                                              color: current === "Por verificar" || current === "No iniciada" ? "#000" : "#fff",
                                            },
                                            "&.Mui-disabled .MuiSelect-icon": {
                                              color: chipColor(current),
                                            },
                                          }}
                                        renderValue={() => (
                                          <Chip
                                            size="small"
                                            label={current}
                                            sx={{
                                              backgroundColor: chipColor(current),
                                              color: current === "Por verificar" || current === "No iniciada" ? "#000" : "#fff",
                                              textFillColor: current === "Por verificar" || current === "No iniciada" ? "#000" : "#fff",
                                            }}
                                          />
                                        )}
                                      >

                                      <MenuItem value={current} disabled>
                                          Pasar a {current}
                                        </MenuItem>
                                        {options.map((opt) => (
                                          <MenuItem key={opt} value={opt}>
                                            {opt}
                                          </MenuItem>
                                        ))}
                                      </Select>
                                    </TableCell>
                                  );
                                } else {
                                  return (
                                    <TableCell
                                      key={"TC" + colIndex + rowIndex}
                                      align={column.align}
                                      sx={{wordBreak: column.id==="email" ? "break-word" : "none"}}
                                    >
                                      {value}
                                    </TableCell>
                                  );
                                }
                              })}
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                  {displayedRows.length === 0 && <ListEmpty />}
                </TableContainer>

                <TablePagination
                  rowsPerPageOptions={[10, 25, 100]}
                  component="div"
                  count={displayedRows.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            </PageBgBlock>

            {includeRol([ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN]) ? (
              <Grid container spacing={2} sx={{ display: "flex" }} columns={14}>
                <Grid size={9}>
                  
                </Grid>
                <Grid size={5}>
                  <PageButtonWhite
                    loading={selected.length === 0}
                    onClick={downloadXLS}
                    width="100%"
                  >
                    Descarga selección en listado (.xlsx)
                  </PageButtonWhite>
                </Grid>
              </Grid>
            ) : null}
          </>
        )}
      </Box>
              <ModalMassiveRepresentantes
          open={open}
          btnText="Ir al listado"
          selected={selected}
          action={action}
          onClick={() => navigate("/Representantes_lista")}
          onClose={handleClose}
        ></ModalMassiveRepresentantes>

         <RepresentantesModalAdd
          open={openAdd}
          selected={selected}
          action={action}
          onClick={() => navigate("/Representantes_lista")}
          onClose={handleCloseAdd}
        ></RepresentantesModalAdd>


        <ModalStandardCancel
        open={openVerify}
        error={true}
        icon={<LocationOnOutlinedIcon color="error" sx={{ fontSize: 55 }}/>}
        title="Verificar dirección"
        qst={verifyMsg}
        msg="Esta actualizará la ficha y datos del RBD, los cuales son visibles para los Representantes del EES, el Operador correspondiente y para SUBTEL."
        btnText={addressNewState === 'Verificada' ? 'OK, verificar dirección' : 'OK, no verificar dirección'}
        onClick={callChangeApi}
        onClose={handleCloseVerify}
      />
    </PageBody>
  );
}